<template>
    <div>
        <table class="hilo-table-v2 table table-bordered">
            <thead :style="{ background: headerColor }">
                <tr class="text-left">
                    <th class="dot" v-if="hasDot"><div></div></th>
                    <th v-for="(column, index) in columns" :key="index" :class="`text-${column.align || 'left'}`" :style="{ width: column.width }">
                        {{ column?.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, rowIndex) in tableData.data" :key="rowIndex">
                    <td v-if="hasDot">
                        <span v-if="!getDataImage(item.id)"></span>
                        <img :src="getDataImage(item.id)" v-else>
                    </td>

                    <td
                        v-for="(column, colIndex) in filteredColumns(rowIndex)"
                        :key="colIndex"
                        :class="`text-${column.align || 'left'}`"
                        :rowspan="getRowspan(rowIndex, column.value)"
                        :colspan="getColspan(rowIndex, column.value)"
                    >
                        <span v-if="column.value === 'action'">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </span>
                        <div v-else-if="column.isUrl">
                            <img src="/static/img/attachment.svg" />
                        </div>
                        <div v-else-if="column.customRender">
                            <slot :name="column.customRender.slotScope" :item="item">
                                {{ item }}
                            </slot>
                        </div>
                        <div v-else>{{ item[column.value] }}</div>
                    </td>
                </tr>
                <tr>
                    <td v-for="(item, index) in tableData.remainingData" :key="index" :colspan="isNaN(item) ? 1 : item">
                        {{ getCellValue(item) }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="data.length < 1" class="text-center mt-4 font-italic text-secondary">
            No Data
        </div>
    </div>
</template>
<script>
export default {
    props: {
        headerColor: {
            type: String,
            default: '#3C78FF'
        },
        hasDot: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            default: () => ([])
        },
        data: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        tableData() {
            const filteredData = this.data.filter(item => {
                return item?.id;
            });

            const remainingData = this.data.filter(item => {
                return !item?.id;
            });


            return { data: filteredData, remainingData: ((remainingData[0] || []).data || {}) };
        },
    },
    methods: {
        getDataImage(id) {
            return this.data.find(rec => rec.id === id)?.image;
        },
        getRowspan(rowIndex, key) {
            const item = this.data[rowIndex];
            return (item?.rowspan || {})[key] || 1;
        },
        getColspan(rowIndex, key) {
            const item = this.data[rowIndex];
            return item?.colspan?.[key] || 1;
        },
        isCellMerged(rowIndex, key) {
            for(let i = 0; i < rowIndex; i++) {
                const span = (this.data[i]?.rowspan || {})?.[key];
                if(span && i + span > rowIndex)
                    return true;
            }
            return false;
        },
        filteredColumns(rowIndex) {
            return this.columns.filter((column) => {
                return !this.isCellMerged(rowIndex, column.value);
            });
        },
        getCellValue(element) {
            return isNaN(element) ? element : '';
        }
    }
}
</script>
<style scoped>
.hilo-table-v2 {
    box-shadow: 0 0 15px 0 #ccc;
    border-radius: 20px;
}

.hilo-table-v2 thead {
    text-align: left !important;
    /* background: #707070; */
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
}

.hilo-table-v2 tbody tr {
    text-align: left !important;
    font-size: 16px !important;
}

.hilo-table-v2 th {
    color: white !important;
    font-size: 14px !important;
    font-weight: 500;
    text-transform: lowercase !important;
    text-transform: capitalize !important;
}

.hilo-table-v2 thead th:first-child {
    border-top-left-radius: 15px !important;
}

.hilo-table-v2 thead th:last-child {
    border-top-right-radius: 15px !important;
}

.hilo-table-v2 tbody tr td {
    border: 1px solid #ccc;
    padding: 5px 10px;
    font-size: 15px;    
}

.hilo-table-v2 tbody tr td img {
    padding: 0 !important;
}

.hilo-table-v2 td span {
    color: #3171e2;
    cursor: pointer;
}
.hilo-table-v2 thead tr .dot {
    width: 30px;
}
.hilo-table-v2 thead tr .dot div {
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
}
</style>
